import zeplinColor from '../theme/Color';

/*
 * File: constants.tsx
 * Project: a-a
 * File Created: Wednesday, 16th October 2024 1:17:43 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 22nd September 2025 7:03:37 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
export class Constants {
  public static readonly ErrorType = {
    NotFound: 'UserNotFoundException',
    NotAuthourized: 'NotAuthorizedException',
    LimitExceeded: 'LimitExceededException',
    ExpiredCode: 'ExpiredCodeException',
  };
  public static readonly ErrorText = {
    ExpiredCodeException: 'Code expired',
    LimitExceededException: 'Attempt limit exceeded. Try again later',
    UserNotFoundException: 'User Not Found',
    NotAuthorizedException: 'Wrong password. Try again or click Forgot password to reset it',
    CodeMismatchException: 'Code not matched.',
  };

  public static readonly PriorityTask = {
    Normal: zeplinColor.Blue,
    Low: zeplinColor.AlertInfo,
    High: zeplinColor.Error,
  };

  public static readonly StatusTask = {
    'To Do': zeplinColor.AlertInfo,
    'In Progress': zeplinColor.Blue,
    Done: zeplinColor.Error,
  };

  public static readonly DealsText = {
    totalDealsWon: 'Monthly Closed Deals',
    totalOpenDeals: 'Monthly Open Deals',
    quaterly: 'Quarterly Revenue',
    totalTasks: 'Tasks Completed',
  };
  public static readonly DealsColor = {
    totalDealsWon: zeplinColor.Blue1,
    totalOpenDeals: zeplinColor.Yellow,
    quaterly: zeplinColor.Green,
    totalTasks: zeplinColor.Blue2,
  };
  public static readonly privacyOptions = [
    {
      label: 'A&A Management Group',
      value: 'public_to_workspace',
      description: 'Everyone in your organization can find and access this project.',
    },
    {
      label: 'Shared with team',
      value: 'private_to_team',
      description: 'Only this team and invited members can find and access this project.',
    },
    {
      label: 'Private to members',
      value: 'private',
      description: 'Only invited members can find and access this project.',
    },
  ];
}

export enum Error {
  NotFound = 'UserNotFoundException',
  NotAuthourized = 'NotAuthorizedException',
  LimitExceeded = 'LimitExceededException',
  ExpiredCode = 'ExpiredCodeException',
  CodeMismatch = 'CodeMismatchException',
}

export enum ClientType {
  Talent = 'Talent',
  Athlete = 'Athlete',
  Business = 'Business Development',
}
